<template>
  <div class="guides">
    <div class="guides-head">
      <span>Группа</span>
      <el-input
        style="width: 200px; margin: 0 15px"
        placeholder="Введите группу"
        v-model="group"
        @change="loadReferences()"
      />
      <el-button @click="loadReferences()" type="primary">Загрузить</el-button>
    </div>
    <el-tabs class="demo-tabs">
      <el-tab-pane
        v-for="reference of referencesList"
        :key="reference.id"
        :label="reference.title"
      >
        <div class="guides-list-item-head">
          <h3 class="guides-list-item-title">{{ reference.title }}</h3>
          <el-button
            type="primary"
            size="small"
            @click="addItemHandler(reference.id)"
            >Добавить</el-button
          >
        </div>
        <div class="guides-references-list">
          <reference-item
            v-for="item of reference.items"
            :key="item.id"
            :reference-item="item"
            :active-edit-item-id="activeEditItemId"
            @onEditItem="editItemHandler"
            @onDeleteItem="deleteItemHandler"
            @onCancelEditItem="cancelEditItemHandler"
            @onAddFile="addFileHandler"
            @onRemoveFile="removeFileHandler"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
    <!--<div class="guides-list">
      <div v-for="reference of referencesList" :key="reference.id" class="guides-list-item">
        <div class="guides-list-item-head">
          <h3 class="guides-list-item-title">{{reference.title}}</h3>
          <el-button type="primary" size="small" @click="addItemHandler(reference.id)">Добавить</el-button>
        </div>
        <div class="guides-references-list">
          <reference-item
            v-for="item of reference.items"
            :key="item.id"
            :reference-item="item"
            :active-edit-item-id="activeEditItemId"
            @onEditItem="editItemHandler"
            @onDeleteItem="deleteItemHandler"
            @onCancelEditItem="cancelEditItemHandler"
            @onAddFile="addFileHandler"
            @onRemoveFile="removeFileHandler"
          />
        </div>
      </div>
    </div>-->

    <el-dialog title="Создание записи" :visible.sync="createDialogVisible">
      <div class="guides-modal">
        <div class="guides-modal-row">
          <label>
            <span>Название</span>
            <el-input v-model="newReferenceName" autocomplete="off"></el-input>
          </label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button>Отмена</el-button>
        <el-button type="primary" @click="saveReferencesItem()"
          >Сохранить</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      width="400px"
      title="Добавление файла"
      :visible.sync="showAddFileModal"
    >
      <el-form
        :model="addFileForm"
        ref="addFileForm"
        label-width="120px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item prop="file">
          <div class="files-upload-list">
            <el-upload
              ref="upload"
              class="upload-demo"
              drag
              action=""
              :http-request="uploadFile"
              :file-list="addFileForm.newFiles"
              :multiple="false"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                {{ $t("feed.settings.common.commonSimpleForm.upload[0]") }}
                <em>{{
                  $t("feed.settings.common.commonSimpleForm.upload[1]")
                }}</em>
              </div>
            </el-upload>

            <ul class="files-list" v-if="addFileForm.files.length">
              <li class="files-list__item-title">
                {{ $t("feed.settings.common.commonSimpleForm.uploaded") }}:
              </li>
              <li
                class="files-list__item"
                v-for="file in addFileForm.files"
                :key="file.link"
              >
                <span class="files-list__item-name">
                  {{ file.filename }}
                </span>
                <el-link
                  type="primary"
                  icon="el-icon-download"
                  :href="file.link"
                  :underline="false"
                  >{{
                    $t("feed.settings.common.commonSimpleForm.download")
                  }}</el-link
                >
              </li>
            </ul>
          </div>
        </el-form-item>
        <!--        <el-button type="primary" @click="submitForm()">Отправить</el-button>-->
        <!--        <el-button type="primary" @click="resetForm('addFileForm')">Отменить</el-button>-->
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// components
import ReferenceItem from "./ReferenceItem.vue";

// api
import {
  getReferencesApi,
  getReferenceAddItemApi,
  getReferenceRemoveItemApi,
} from "../../../../api/references";

// vuex
import { mapGetters } from "vuex";
import {
  referenceAddFileApi,
  referenceRemoveFileApi,
} from "../../../../api/files";
import notify from "../../../../helpers/notify";

export default {
  name: "Guides",
  data() {
    return {
      group: "",
      referencesList: [],
      currentReferenceId: null,
      createDialogVisible: false,
      newReferenceName: "",
      newReferenceKeyword: "",
      newReferenceKeywordList: [],
      activeEditItemId: null,
      addFileForm: {
        files: [],
      },
      showAddFileModal: false,
      addFileReferenceItemId: null,
      roles: this.$t("user.roles"),
    };
  },
  computed: {
    ...mapGetters(["users", "isAdmin"]),
  },
  methods: {
    getRole(role) {
      return this.roles.find((item) => item.name === role).title;
    },
    loadReferences() {
      if (this.group !== "") {
        const params = {
          group_id: parseInt(this.group),
        };
        getReferencesApi(params).then((resp) => {
          this.referencesList = resp.data.filter((it)=> it.id == 8 || it.id == 1 || it.id == 2 || it.id == 3 || it.id == 4 );
        });
      }
    },
    addItemHandler(id) {
      this.currentReferenceId = id;
      this.createDialogVisible = true;
    },
    editItemHandler(id) {
      this.activeEditItemId = id;
    },
    cancelEditItemHandler() {
      this.activeEditItemId = null;
    },
    deleteItemHandler(id) {
      getReferenceRemoveItemApi({ item_id: id }).then(() => {
        this.loadReferences();
      });
    },
    addFileHandler(id) {
      this.addFileReferenceItemId = id;
      this.showAddFileModal = true;
    },
    uploadFile(file) {
      console.log("uploadFile", file);
      let fd = new FormData();
      fd.append("upfile", file.file, file.file.name);
      fd.append("reference_item_id", String(this.addFileReferenceItemId));

      referenceAddFileApi(fd)
        .then(() => {
          notify.call(this, `Файл ${file.file.name} загружен`, "success");
        })
        .catch(() => {
          notify.call(this, "Ошибка сервера", "error");
        })
        .finally(() => {
          this.$refs.upload.clearFiles();
          this.showAddFileModal = false;
          this.loadReferences();
        });
    },
    removeFileHandler(id) {
      const params = {
        reference_item_id: id,
      };

      referenceRemoveFileApi(params)
        .then(() => {
          notify.call(this, `Файл удален`, "success");
        })
        .catch(() => {
          notify.call(this, "Ошибка сервера", "error");
        })
        .finally(() => {
          this.loadReferences();
        });
    },
    saveReferencesItem() {
      if (!this.currentReferenceId && this.newReferenceName === "") {
        return;
      }

      const params = {
        reference_id: this.currentReferenceId,
        keyword: this.newReferenceName,
        group_id: parseInt(this.group),
      };
      getReferenceAddItemApi(params).then(() => {
        this.currentReferenceId = null;
        this.newReferenceName = "";
        this.createDialogVisible = false;
        this.loadReferences();
      });
    },
  },
  components: {
    ReferenceItem,
  },
};
</script>

<style>
.guides-head {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.guides-list {
}
.guides-list-item:not(:last-child) {
  margin-bottom: 40px;
}
.guides-list-item-head {
  display: flex;
  align-items: center;
  margin: 0 0 15px;
}
.guides-list-item-head .el-button--small,
.el-button--small.is-round {
  padding: 4px 15px;
}
.guides-list-item-title {
  margin: 0 20px 0 0;
}
.guides-references-list {
}
.guides-references-list-item {
}
.guides-modal-row {
}
.guides-modal-row span {
  display: block;
  margin-bottom: 5px;
}
.el-tabs__item {
  position: relative;
  display: inline-block;
  line-height: 12px;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 9px 15px !important;
  margin-right: 10px;
  font-size: 12px;
  border-radius: 4px;
  height: unset;
}

.el-tabs__item.is-active {
  color: white;
  background: #409eff;
}

.el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  background-color: unset !important;
}
.el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0;
  background-color: #e4e7ed;
  z-index: 1;
}

@media screen and (max-width: 480px) {
  .guides-references-keywords-edit-row .el-button {
    margin-top: 10px
  }
  .el-dialog{
    width: 80%;
  }
  .el-tabs__nav-scroll {
    overflow-x: auto;
  }
  .el-tabs__nav-wrap.is-scrollable {
    padding: 0;
  }
  .el-tabs__item {
    padding: 9px!important;
  }
}
</style>
